import React, { Component } from 'react'
// import MainMicrosoftOfficeExcel2010 from './main_microsoft_office_excel_2010'
import { Helmet } from 'react-helmet'
import DictsInfo from '../../components/dicts_info.jsx'

// import { Link } from 'react-router-dom';
// import GambarPointer1 from './img/pointer1.png'

// function refreshPage(){
//     setTimeout(()=>{
//       window.location.reload(false);
//     }, 500);
   
//   }


export default class MengenalFungsiTeksPadaMsOfficeExcel2010FungsiRight extends Component {
  render() {
    return (
      <div>

      <Helmet>
        <title>Mengenal Fungsi Teks Pada Microsoft Office Excel 2010 - Fungsi CHAR</title>
        <meta name="description" content="belajar Microsoft Office Excel 2010, tutorial Microsoft Office Excel 2010, tutorial Microsoft Excel 2010 untuk pemula, berapa bagian Microsoft Excel"/>
      </Helmet>
      
        <section className="colorlib-about">
          <div className="colorlib-narrow-content">
            <div className="row">

              {/* <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInBottom"> */}
              <div className="col-md-9 col-md-offset-0 col-md-pull-0" >

              {/* <br/>
              <br/> */}
                  
                  
                <h1 style={{fontSize: '1.5rem'}} className="colorlib-heading">Mengenal Fungsi Teks Pada Microsoft Office Excel 2010</h1>

                <h2>Fungsi RIGHT</h2>
                <p>apa fungsi <b>RIGHT</b> pada microsoft office excel 2010?</p>
                <p>pada microsoft office excel 2010 fungsi <b>RIGHT</b> berfungsi untuk mengambil teks sebelah kanan.</p>
                <p>Bentuk penulisannya adalah:</p>
                <p><b>=RIGHT(teks;[num_chars])</b></p>
                <li><b>teks</b> adalah isi teks yang akan diambil.</li>
                <li><b>num_chars</b> adalah jumlah karakter yang ingin diambil dari sebelah kanan.</li>
                <p>Contoh:</p>
                <div className= "w3-container" > 
                    <div className= "w3-container" > 
                        <ul> 
                            <li>Data dalam sel A1 adalah <b>Dictionary Plus+</b>.</li>
                            <li>Apabila kita ingin mengambil teks <b>Plus+</b> nya saja maka fungsi yang dituliskan adalah <b>=RIGHT(A1;5)</b>.</li>
                            <li>Maka hasilnya adalah <b>Plus+</b>.</li>
                        </ul> 
                    </div>
                </div>
                
                <br/>
                <p><b>Semoga Bermanfaat..</b></p>
               
              </div>
              <DictsInfo/>
            </div>

            {/* <div className="row row-pt-md"></div> */}

          </div>
        </section>
        {/* <MainMicrosoftOfficeExcel2010/> */}
      </div>
    )
  }
}
